




























































































































import Vue from "vue";
import Component from "vue-class-component";
import {AdditionalIngredientsGroup, IAdditionalIngredientsGroup} from "@/data/AdditionalIngredientsGroup";
import {Prop} from "vue-property-decorator";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import ConfirmDialog from "@/components/ConfirmDialog.vue";

@Component({
    components: {ConfirmDialog, ValidationProvider, ValidationObserver}
})
export default class AdditionalIngredientsGroupsView extends Vue {

    loading: boolean = false;
    disabled: boolean = false;
    editing: boolean = false;

    editedGroup: IAdditionalIngredientsGroup = new AdditionalIngredientsGroup().copy({});

    @Prop()
    readonly group?: IAdditionalIngredientsGroup;

    @Prop({required: true})
    readonly onSave!: (editedGroup: IAdditionalIngredientsGroup) => Promise<void>;

    @Prop({required: true})
    readonly onSaveError!: (error: any) => Promise<void>;

    @Prop()
    readonly onDelete?: (editedGroup: IAdditionalIngredientsGroup) => Promise<void>;

    @Prop()
    readonly onDeleteError?: (error: any) => Promise<void>;

    @Prop()
    readonly onCancel?: () => Promise<void>;

    @Prop({default: () => false})
    readonly creation!: boolean;

    beforeMount() {
        this.editing = this.creation;
    }

    edit() {
        this.editing = true;
        AdditionalIngredientsGroup.copy(this.group!, this.editedGroup);
    }

    cancel() {
        this.editing = false;
        this.onCancel?.();
    }

    async deleteGroup() {
        if (this.onDelete)
            await this.onDelete(this.editedGroup);
    }

    async deleteError(error: any) {
        if (this.onDeleteError) {
            this.onDeleteError(error);
        }
    }

    async save() {
        this.loading = true;
        this.disabled = true;

        try {
            await this.onSave(this.editedGroup);

            if (!this.creation)
                this.editing = false;
        } catch (error) {
            console.error(error);
            await this.onSaveError(error);
        }

        this.loading = false;
        this.disabled = false;
    }

}
